import { Controller, useFormContext } from 'react-hook-form'
import { Divider } from '../../../../components'
import { Label, StyledInput } from '../../styled'
import { useTranslation } from 'react-i18next'

export const Description = () => {
  const { control } = useFormContext()
  const { t } = useTranslation('appointments')

  return (
    <>
      <Label>{t('description')}</Label>

      <Divider height={10} />

      <Controller
        name="description"
        control={control}
        render={({ field: { onChange, ...field } }) => (
          <StyledInput
            {...field}
            onChange={onChange}
            placeholder={t('enterDescription')}
          />
        )}
      />
    </>
  )
}
